// src/pages/admin/AdminLayout.js
import { useEffect } from 'react';
import { Routes, Route, NavLink, Navigate, useNavigate } from 'react-router-dom';
import { styled } from 'baseui';
import { Button } from 'baseui/button';
import { useLocale } from '../../contexts/LocaleContext';
import { useAuth } from '../../contexts/AuthContext';
import { useAd } from '../../contexts/AdContext';

import AdminUserDashboard from './AdminUserDashboard';
import AdminTournamentDashboard from './AdminTournamentDashboard';

const AdminPageContainer = styled('div', {
  display: 'flex',
  height: '100%',
});

const AdminNav = styled('nav', ({ $theme }) => ({
  flex: '0 0 240px',
  padding: $theme.sizing.scale600,
  backgroundColor: $theme.colors.backgroundSecondary,
  borderRight: `1px solid ${$theme.colors.borderOpaque}`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

const AdminContent = styled('main', ({ $theme }) => ({
  flex: '1 1 auto',
  padding: $theme.sizing.scale800,
  overflowY: 'auto',
}));

const StyledNavLink = styled(NavLink, ({ $theme }) => ({
  display: 'block',
  padding: `${$theme.sizing.scale500} ${$theme.sizing.scale600}`,
  marginBottom: $theme.sizing.scale300,
  textDecoration: 'none',
  color: $theme.colors.contentPrimary,
  borderRadius: $theme.borders.radius400,
  ':hover': {
    backgroundColor: $theme.colors.backgroundTertiary,
  },
  '&.active': {
    backgroundColor: $theme.colors.accent,
    color: $theme.colors.contentInversePrimary,
  }
}));

const AdminLayout = () => {
  const { t } = useLocale();
  const { currentUser } = useAuth();
  const { updateAdVisibility } = useAd();
  const navigate = useNavigate();

  useEffect(() => {
    updateAdVisibility(currentUser, 'admin');
  }, [currentUser, updateAdVisibility]);

  return (
    <AdminPageContainer>
      <AdminNav>
        <div>
          <StyledNavLink to="users">{t('admin.nav.users')}</StyledNavLink>
          <StyledNavLink to="tournaments">{t('admin.nav.tournaments')}</StyledNavLink>
        </div>
        <div>
          <Button onClick={() => navigate('/dashboard')} kind="tertiary" overrides={{ BaseButton: { style: { width: '100%' } } }}>
            {t('common.backToDashboard')}
          </Button>
        </div>
      </AdminNav>
      <AdminContent>
        <Routes>
          <Route path="/" element={<Navigate to="users" replace />} />
          <Route path="users" element={<AdminUserDashboard />} />
          <Route path="tournaments" element={<AdminTournamentDashboard />} />
        </Routes>
      </AdminContent>
    </AdminPageContainer>
  );
};

export default AdminLayout;
